/**
 * Pinterest Ads loader
 *
 * The browser pixel is part of the free plugin. The server-side helpers in
 * functions_premium.js only exist on Pro builds.
 */

require("./adapter")
require("./functions")
require("./event_listeners")

// #if process.env.TIER === 'premium'
if (pmw.canLoadPremiumFeatures()) {
	require("./functions_premium")
}
// #endif
